import React from "react";
import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { ButtonBadgesTitle } from "../../../Constants/Constants";
import { ButtonBadgesData, ButtonBadgesSubTitle } from "../../../Data/UiKits/Tag&Pills";
import { Badges, Btn } from "../../../AbstractElements";

const ButtonBadges = () => {
  return (
    <Col xs="12">
      <Card>
        <CommonCardHeader title={ButtonBadgesTitle} span={ButtonBadgesSubTitle} />
        <CardBody>
          <div className="badge-flex">
            {ButtonBadgesData.map((item, index) => (
              <Btn color={item.color} className={` ${item.buttonClass}`} key={index}>
                {item.title}
                <Badges color="danger" className={`ms-2 ${item.badgesClass}`}>
                  {item.text}
                </Badges>
              </Btn>
            ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ButtonBadges;
